import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getPlansApiCall, getApiCall } from "../../utils/Apicalls";
import Header from "../../components/common/header/Header";
import Footer from "../../components/common/footer/Footer";
import SpinnerShow from "../../components/Spinner";
import "./home.css";

function PlansPage() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in
    const userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      setIsLoggedIn(true);
    }

    const fetchPlans = async () => {
      try {
        const result = await getPlansApiCall();
        
        if (result?.status && result?.result) {
          setPlans(result.result);
        } else {
          setError("Failed to load plans data");
        }
      } catch (err) {
        console.error("Error fetching plans:", err);
        setError("An error occurred while fetching plans. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  // Function to check remaining time and redirect accordingly
  const handlePlanSelection = async (e, plan) => {
    e.preventDefault();
    
    if (!isLoggedIn) {
      // If not logged in, redirect to signup
      navigate('/signup');
      return;
    }
    
    try {
      // Check remaining time
      const timeResult = await getApiCall('interview-app/interview/details');
      
      if (timeResult && timeResult.result) {
        const remainingMinutes = timeResult.result.remainingMinutes || 0;
        
        if (remainingMinutes <= 0) {
          // No remaining time, redirect to checkout
          navigate('/checkout');
        } else {
          // Has remaining time, redirect to interview page
          navigate('/home');
        }
      } else {
        // If API call fails, default to checkout
        navigate('/checkout');
      }
    } catch (error) {
      console.error('Error checking remaining time:', error);
      // If error occurs, default to checkout
      navigate('/checkout');
    }
  };

  const renderPlanFeatures = (description) => {
    return description.map((feature, index) => (
      <div key={index} className="feature-item available">
        <span className="check">✓</span>
        <span>{feature.name}</span>
      </div>
    ));
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="loading-container" style={{ minHeight: "60vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <SpinnerShow />
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <main className="home-content">
        <section className="pricing-section" style={{ padding: '40px 0' }}>
          <div className="container">
            <h2>Choose Your Plan</h2>
            
            {error ? (
              <div className="error-message" style={{ textAlign: "center", color: "#dc3545", margin: "30px 0" }}>
                {error}
                <div style={{ marginTop: "20px" }}>
                  <button 
                    onClick={() => window.location.reload()} 
                    style={{ 
                      padding: "10px 20px", 
                      backgroundColor: "#6979f8", 
                      color: "white", 
                      border: "none", 
                      borderRadius: "4px", 
                      cursor: "pointer" 
                    }}
                  >
                    Try Again
                  </button>
                </div>
              </div>
            ) : (
              <div className="pricing-grid">
                {plans.map((plan) => (
                  <div className="pricing-card" key={plan.id}>
                    <div className="pricing-header">
                      <h3>{plan.name.toUpperCase()}</h3>
                      <div className="price">
                        <span className="currency">$</span>
                        <span className="amount">{plan.price}</span>
                        <span className="period">/ {plan.session_time} {parseInt(plan.session_time) === 1 ? "min" : "mins"} session</span>
                      </div>
                    </div>
                    <div className="pricing-features">
                      <div className="feature-item available">
                        <span className="check">✓</span>
                        <span>{plan.session_time} {parseInt(plan.session_time) === 1 ? "min" : "mins"} session</span>
                      </div>
                      {renderPlanFeatures(plan.description)}
                    </div>
                    {isLoggedIn ? (
                      // eslint-disable-next-line jsx-a11y/anchor-is-valid
                      <a 
                        href="#" 
                        className="pricing-cta" 
                        onClick={(e) => handlePlanSelection(e, plan)}
                      >
                        {plan.price === "0" ? "Try for free" : "Get the plan"}
                      </a>
                    ) : (
                      <Link to="/signup" className="pricing-cta">
                        {plan.price === "0" ? "Try for free" : "Get the plan"}
                      </Link>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default PlansPage;





